<template>
	<tr class="align-middle text-center">
		<td>
			<template v-if="item.editable == 1">
				<template v-if="containers.edit">
					<button class="btn btn-xs btn-icon btn-light-primary" @click="onSave">
						<span class="fa fa-fw fa-save"></span>
					</button>

					<button
						class="btn btn-xs btn-icon btn-light-secondary text-dark ml-1"
						@click="onCancel"
					>
						<span class="fa fa-fw fa-times"></span>
					</button>
				</template>
				<button
					v-else
					class="btn btn-xs btn-icon btn-light-warning"
					@click="onEdit"
				>
					<span class="fa fa-fw fa-pencil-alt"></span>
				</button>
			</template>
		</td>
    <td>{{ item.nombre }}</td>
		<td>
			<template v-if="!containers.edit">{{ item.valor }}</template>
			<template v-else>
				<ValidationObserver ref="form">
					<!-- <me-valid-input
						v-model="form.valor"
						:name="item.nombre"
						:rules="item.regla"
						:inputOptions="{
              class: 'table-form-control'
            }"
					/> -->
				</ValidationObserver>
			</template>
		</td>
    <td>{{ item.usuarioModif }}</td>
	</tr>
</template>

<script>
// import MeValidInput from './reusable/MeValidInput.vue';
export default {
	// components: { MeValidInput },
	name: "TrMantenimientoGeneral",
	props: {
		item: Object,
	},
	data() {
		return {
			form: {
				valor: "",
			},
			containers: {
				edit: false,
			},
		};
	},
	methods: {
		onEdit() {
			this.form.valor = this.item.valor;
			this.containers.edit = true;
		},
		onCancel() {
			this.form.valor = "";
			this.containers.edit = false;
		},
		async onSave() {
			const vm = this;

			const success = await vm.$refs.form.validate();

			if (!success) return;

      try {
        let response = await vm.axios.put(`/mantenimiento/generales/${vm.item.idGeneral}`, {
          valor: vm.form.valor
        })

        vm.$toast.fire(response.data.message, '', 'success');
        vm.item.valor = vm.form.valor;
        vm.containers.edit = false;
      } catch (error) {
        console.error(error);
      }
		},
	},
};
</script>